import { defineMessages } from '@atlassian/jira-intl';

export const messages = defineMessages({
	defaultValueTooLongErrorDescription: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.default-value-too-long-error-description',
		defaultMessage: 'Your description is too long.',
		description: 'Validation error shown to the user if too long text is typed in the editor.',
	},
	defaultValueTooLongErrorValue: {
		id: 'project-settings-apps.issue-type-page.field-associated.field-configuration.multiline.default-value-too-long-error-value',
		defaultMessage: 'Your text is too long.',
		description: 'Validation error shown to the user if too long text is typed in the editor.',
	},
});
